export default () => ({
  '@global': {
    body: {
      overflow: 'hidden'
    }
  }
});
